"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./ScreenLoader.css");
var InfiniteLoader_1 = require("../InfiniteLoader/");
var ScreenLoader = /** @class */ (function (_super) {
    __extends(ScreenLoader, _super);
    function ScreenLoader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ScreenLoader.prototype.getScreenLoaderStyles = function () {
        return {
            top: this.props.options && this.props.options.verticalOffset ? this.props.options.verticalOffset : '0',
        };
    };
    ScreenLoader.prototype.render = function () {
        if (this.props.options && this.props.options.isEnabled === false) {
            return null;
        }
        return (React.createElement("div", { className: styles.screenLoader, "data-test-id": this.props.testId, style: this.getScreenLoaderStyles() },
            React.createElement(InfiniteLoader_1.default, null)));
    };
    return ScreenLoader;
}(React.Component));
exports.default = ScreenLoader;
//# sourceMappingURL=ScreenLoader.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/ScreenLoader/ScreenLoader.js
// module id = 1240
// module chunks = 8